export const getOrderedNodes = (nodes: any[], connections: any[]) => {
  if (!nodes || nodes.length === 0) return [];
  
  const incoming = new Set((connections || []).map(c => c.toId));
  const startNodes = nodes.filter(n => !incoming.has(n.id));
  
  // Sort start nodes left-to-right
  startNodes.sort((a, b) => ((a.position?.x || 0) - (b.position?.x || 0)));
  
  const ordered: any[] = [];
  const visited = new Set();
  const queue = [...startNodes];
  
  while (queue.length > 0) {
    const node = queue.shift();
    if (!node || visited.has(node.id)) continue;
    visited.add(node.id);
    ordered.push(node);
    
    // Find outgoing connections from this node
    const outgoing = (connections || [])
      .filter(c => c.fromId === node.id)
      .map(c => c.toId);
      
    const nextNodes = nodes.filter(n => outgoing.includes(n.id));
    // Sort outgoing branches left-to-right
    nextNodes.sort((a, b) => ((a.position?.x || 0) - (b.position?.x || 0)));
    
    queue.push(...nextNodes);
  }
  
  // Append any orphaned/disconnected nodes sorted left-to-right
  const orphans = nodes.filter(n => !visited.has(n.id));
  orphans.sort((a, b) => ((a.position?.x || 0) - (b.position?.x || 0)));
  ordered.push(...orphans);
  
  return ordered;
};
